__turbopack_context__.v({
  "accessIcon": "PlaylistCard-module__NJMesW__accessIcon",
  "accessStatus": "PlaylistCard-module__NJMesW__accessStatus",
  "card": "PlaylistCard-module__NJMesW__card",
  "cardWrapper": "PlaylistCard-module__NJMesW__cardWrapper",
  "description": "PlaylistCard-module__NJMesW__description",
  "favorited": "PlaylistCard-module__NJMesW__favorited",
  "icon": "PlaylistCard-module__NJMesW__icon",
  "image": "PlaylistCard-module__NJMesW__image",
  "imageWrapper": "PlaylistCard-module__NJMesW__imageWrapper",
  "menuIcon": "PlaylistCard-module__NJMesW__menuIcon",
  "pauseOverlayButton": "PlaylistCard-module__NJMesW__pauseOverlayButton",
  "playButton": "PlaylistCard-module__NJMesW__playButton",
  "playOverlayButton": "PlaylistCard-module__NJMesW__playOverlayButton",
  "playlistMenu": "PlaylistCard-module__NJMesW__playlistMenu",
  "scrollArea": "PlaylistCard-module__NJMesW__scrollArea",
  "shareButton": "PlaylistCard-module__NJMesW__shareButton",
  "shareMenu": "PlaylistCard-module__NJMesW__shareMenu",
  "shareOverlayButton": "PlaylistCard-module__NJMesW__shareOverlayButton",
  "subMenu": "PlaylistCard-module__NJMesW__subMenu",
  "title": "PlaylistCard-module__NJMesW__title",
});
